import { makeAutoObservable } from 'mobx'
import { type PageLayoutStore } from 'shared/layout'

export class ChatbotLayoutStore {
  constructor(private _pageLayoutStore: PageLayoutStore) {
    makeAutoObservable(this)
  }

  get pageLayoutStore() {
    return this._pageLayoutStore
  }
}
